import "core-js/modules/es.array.fill.js";
import * as React from 'react';
import { useTheme } from '@material-ui/core';
function CloseOutlineIcon(props) {
  var size = props.size === 'xlarge' ? 64 : 24;
  var theme = useTheme();
  var color = props.color ? theme.palette[props.color].main : 'currentColor';
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    width: size,
    height: size,
    fill: props !== null && props !== void 0 && props.fill ? props.fill : 'none',
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props['aria-label'],
    "aria-hidden": props['aria-hidden']
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.707 6.293a1 1 0 00-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 101.414 1.414L12 13.414l4.293 4.293a1 1 0 001.414-1.414L13.414 12l4.293-4.293a1 1 0 00-1.414-1.414L12 10.586 7.707 6.293z",
    fill: props.fill ? props.fill : color
  }));
}
export default CloseOutlineIcon;